/**
 *  Tab script file
**/

export default {
  name: 'Tab',
  mixins: [],
  components: {},
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    badge: {
      type: [String, Number],
      required: false
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
  },
  mounted () {
    this.isActive = this.selected
  },
  methods: {
  }
}
